import React, { useEffect, useState } from "react";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import { useNavigate, useParams } from "react-router-dom";
import { useDashboardContext } from "../../../context/dashboardContext";
import Loader from "../../../components/loader";
import { getApiUrl } from "../../../data/api/apiManager";

import UserVerifiedIcon from "../../../components/userVerifiedIcon";
import LinkIcon from "../../../assets/icons/linkIcon";
import AccountIcon from "../../../assets/icons/accountIcon";
import InfoBoxes from "../../../components/infoBoxes";
import { formatDate } from "../../../utils/dateUtils";
import Button from "../../../components/button";
import { AccountAdminResponseDTO, ArtistAdminResponseDTO } from "../../../openapi-generated-client";
import BookIcon from "../../../assets/icons/bookIcon";

export default function DashboardSingleAccountManagementPage() {
    const navigate = useSafeNavigate(useNavigate());

    const {id} = useParams();

    const {appContext, sessionId} = useDashboardContext();
    const {accountController} = appContext;

    const [data, setData] = useState<AccountAdminResponseDTO>();
    const [error, setError] = React.useState<string | undefined>(undefined);

    async function fetchData() {
        setData((await accountController.getAccount(sessionId, Number(id))).data);
    }

    useEffect(() => {
        fetchData();
    }, [id]);


    if(isNaN(Number(id))) {
        window.location.href="/error/2";
        return <></>;
    }

    if(data == undefined) return <Loader/>;

    return  <div className="page admin-account-page">
        <div className="artist-info">
            <img onError={(e) => {
                fetch("/artist-placeholder.webp")
                .then((response) => response.blob()) // Convert the image to a Blob
                .then((blob) => {
                    const file = new File([blob], "artist-placeholder.webp", { type: blob.type });
                    e.currentTarget.src = URL.createObjectURL(file);
                })
                .catch((error) => console.error("Error loading image as file:", error));
            }} className="profile-picture" src={getApiUrl("assets/by-hash/" + data.artist?.profilePicture)}/>
            <h1>{data.name}
            {data.artist && <UserVerifiedIcon artist={data.artist}/>}
            </h1>
            {data.artist && <p>{data.artist.shortBiography}</p>}
            <div className="link-buttons">
                {data.artist && <div className="open-profile" onClick={() => {
                    window.open("/artists/" + data.artist!.id, "_blank")
                }}>
                    <LinkIcon/>
                </div>}
                {data.artist && <div className="open-profile" onClick={() => {
                    navigate("/dashboard/admin/artists/" + data.artist!.id + "/profile");
                }}>
                    <BookIcon/>
                </div>}
            </div>
        </div>
        

        <InfoBoxes infos={[
            { title: ["Pieces", "Likes", "Downloads"], value: [data.piecesAmount, data.likesAmount, data.downloadsAmount] },
            { title: ["Joined", "Last Seen"], value: [formatDate(new Date(data.joined)), formatDate(new Date(data.lastSeen))] }
        ]}/>
        <div className="txoria-text-field">
            <label>Pieces AVG Score</label>
            <a>{Math.round(data.avgPieceScore)}</a>
        </div>
        <p className="error">{error}</p>
        <div className="buttons">
            <Button onClick={async function() {
                await accountController.confirm1(sessionId, {
                    confirmed: !data.verified,
                    account: data.accountId
                }).then(() => {
                    fetchData();
                }).catch((e) => {
                    setError(e.response.data.message || "An error occurred while verifying the account.");
                });
            }} className="primary">{data.verified ? "Unverify" : "Verify"}</Button>
            <Button onClick={async function() {
                accountController.block(sessionId, {
                    confirmed: !data.blocked,
                    account: data.accountId
                }).then(() => {
                    fetchData();
                }).catch((e) => {
                    setError(e.response.data.message || "An error occurred while verifying the account.");
                });
            }} className="primary">{data.blocked ? "Unblock" : "Block"}</Button>
        </div>

    </div>
}